module.exports = __webpack_public_path__ + "img/精致美型--瘦脸gif.30a8af1d.gif";